import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { Layout } from "./layout";

import Users from "./users";
import Organizations from "./organizations";
import Candidates from "./candidates";
import Jobs from "./jobs";
import Channels from "./channels";
import Conversations from "./conversations";
import Applications from "./applications";
import LinkedInRotation from "./linkedin-rotation";
import Qualification from "./qualification";
import Usage from "./usage";
import ChatLayout from "@/components/ChatLayout";

export default function Admin() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="organizations" replace />} />
        <Route path="users/*" element={<Users />} />
        <Route path="organizations/*" element={<Organizations />} />
        <Route path="candidates/*" element={<Candidates />} />
        <Route path="jobs/*" element={<Jobs />} />
        <Route path="channels/*" element={<Channels />} />
        <Route path="conversations/*" element={<Conversations />} />
        <Route path="applications/*" element={<Applications />} />
        <Route path="linkedin-rotation/*" element={<LinkedInRotation />} />
        <Route path="qualification/*" element={<Qualification />} />
        <Route path="usage" element={<Usage />} />
        <Route path="chat/*" element={<ChatLayout basePath="/admin/chat" />} />
      </Route>
    </Routes>
  );
}
